import React, { Fragment } from 'react'

import QuickStartGuidePage from '@/docs-partials/api/quick-start-guide.mdx'
import ResponsePage from '@/docs-partials/api/response-codes.mdx'
import EndpointsPage from '@/docs-partials/endpoints/endpoints'
import SchemaPage from '@/docs-partials/api/schema/schema'
import SectionHeader from '@/docs-partials/sdk/section-header.mdx'
import { DocsSection } from '@/components/common/docs-section'

const Api = () => {
  return (
    <Fragment>
      <div>
        <SectionHeader />
        <DocsSection pathname="/docs/api" anchorId="quick-start-guide">
          <QuickStartGuidePage />
        </DocsSection>
        <DocsSection anchorId="endpoint">
          <EndpointsPage />
        </DocsSection>
        <DocsSection anchorId="schema">
          <SchemaPage />
        </DocsSection>
        <DocsSection pathname="/docs/api" anchorId="response-codes">
          <ResponsePage />
        </DocsSection>
      </div>
    </Fragment>
  )
}

export default Api
